import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b899b09a&scoped=true&lang=pug&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=b899b09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899b09a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
